import * as React from "react";
const SvgFiRrReferArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-refer-arrow_svg__a)">
      <path
        fill="#062147"
        d="m23.268 17.768-2.955 2.955a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L21.208 17h-3.707a2.5 2.5 0 0 0-2.5 2.5V23a1 1 0 1 1-2 0v-3.5c0-2.481 2.019-4.5 4.5-4.5h3.707l-2.293-2.293a.999.999 0 1 1 1.414-1.414l2.939 2.939a2.503 2.503 0 0 1 0 3.536M14 6c0 3.309-2.691 6-6 6S2 9.309 2 6s2.691-6 6-6 6 2.691 6 6m-2 0c0-2.206-1.794-4-4-4S4 3.794 4 6s1.794 4 4 4 4-1.794 4-4m-.752 8.283A9 9 0 0 0 9 14c-4.963 0-9 4.037-9 9a1 1 0 1 0 2 0c0-3.859 3.141-7 7-7 .592 0 1.181.074 1.752.221a1.001 1.001 0 0 0 .496-1.938"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-refer-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrReferArrow;
